
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sandbox/interactions-generator",
      function () {
        return require("private-next-pages/sandbox/interactions-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sandbox/interactions-generator"])
      });
    }
  